<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_vii"><em>Consulting Editors</em></a></h1><a id="page_vii">
<p class="fm-para"><strong>E<span class="smallcaps">STHER</span> C<span class="smallcaps">HAZON</span></strong> Hebrew University of Jerusalem, Israel</p>
<p class="fm-para"><strong>S<span class="smallcaps">HAYE</span> J. D. C<span class="smallcaps">OHEN</span></strong> Harvard University, Cambridge, Massachusetts</p>
<p class="fm-para"><strong>D<span class="smallcaps">EVORAH</span> D<span class="smallcaps">IMANT</span></strong> Haifa University, Israel</p>
<p class="fm-para"><strong>H<span class="smallcaps">ANAN</span> E<span class="smallcaps">SHEL</span></strong>† Bar-Ilan University, Ramat-Gan, Israel</p>
<p class="fm-para"><strong>E<span class="smallcaps">RICH</span> S. G<span class="smallcaps">RUEN</span></strong> University of California, Berkeley</p>
<p class="fm-para"><strong>M<span class="smallcaps">ARTHA</span> H<span class="smallcaps">IMMELFARB</span></strong> Princeton University, New Jersey</p>
<p class="fm-para"><strong>J<span class="smallcaps">AMES</span> L. K<span class="smallcaps">UGEL</span></strong> Bar-Ilan University, Ramat-Gan, Israel</p>
<p class="fm-para"><strong>H<span class="smallcaps">INDY</span> N<span class="smallcaps">AJMAN</span></strong> University of Toronto, Ontario</p>
<p class="fm-para"><strong>G<span class="smallcaps">EORGE</span> W. E. N<span class="smallcaps">ICKELSBURG</span></strong> University of Iowa, Iowa City</p>
<p class="fm-para"><strong>L<span class="smallcaps">AWRENCE A.</span> S<span class="smallcaps">CHIFFMAN</span></strong> New York University, New York</p>
<p class="fm-para"><strong>M<span class="smallcaps">ICHAEL</span> E. S<span class="smallcaps">TONE</span></strong> Hebrew University of Jerusalem, Israel</p>
<p class="fm-para"><strong>J<span class="smallcaps">AMES</span> C. V<span class="smallcaps">ANDERKAM</span></strong> University of Notre Dame, Indiana</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Consulting_Editors.vue?1b56c1c4